export default "__VITE_ASSET__BAQBtMIF__"